document.addEventListener('DOMContentLoaded', registerCookieBanner);
document.addEventListener('turbo:load', registerCookieBanner);

function registerCookieBanner() {
  const acceptBtn = document.getElementById('accept-cookies');
  const banner = document.getElementById('cookie-banner');

  if (acceptBtn && banner) {
    acceptBtn.addEventListener('click', () => {
      const expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      document.cookie = `cookie_eu_consented=true; path=/; expires=${expiryDate.toUTCString()}`;
      banner.remove();
    });
  }
}
